module.exports =
  base: '/graphql'
  dashboard: '/graphql/dashboard'
  service: '/graphql/:service'
  dev:
    base: '/dev'
    full: '/graphql/dev'
    dashboard: '/graphql/dashboard/dev'
    service: '/graphql/:service/dev'
  health:
    base: '/graphql/__health'
    metrics: '/graphql/__health/metrics'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/graphql.coffee